export const STUDENTS_LIST_STEP = 'studentsListStep';
export const LINK_ASSIGNMENT_ARIA_LABEL =
  'Turn into an extension of another assignment';
export const LINK_ASSIGNMENT_TITLE =
  'Turn into an extension of another assignment';
export const LINK_EXTENSION_TITLE_ID = 'link-extension-title';
export const REMOVE_FROM_EXTENSION_TOOLTIP = 'Remove from extension';
export const ADD_TO_EXTENSION_TOOLTIP = 'Add to extension';
